module.exports = __webpack_public_path__ + "img/slide-1.12a9c7cf.jpg";